/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CertificateResponseDto
 */
export interface CertificateResponseDto {
    /**
     * Certificate ID
     * @type {string}
     * @memberof CertificateResponseDto
     */
    id: string;
    /**
     * Certificate type (ROOT_CA, INTERMEDIATE_CA, SERVER, CLIENT)
     * @type {string}
     * @memberof CertificateResponseDto
     */
    type: string;
    /**
     * Certificate status (ACTIVE, REVOKED, EXPIRED)
     * @type {string}
     * @memberof CertificateResponseDto
     */
    status: string;
    /**
     * Certificate Common Name (CN)
     * @type {string}
     * @memberof CertificateResponseDto
     */
    commonName: string;
    /**
     * Certificate PEM content
     * @type {string}
     * @memberof CertificateResponseDto
     */
    serialNumber: string;
    /**
     * Certificate fingerprint (SHA-256 hash)
     * @type {string}
     * @memberof CertificateResponseDto
     */
    fingerprint: string;
    /**
     * Certificate issue date
     * @type {Date}
     * @memberof CertificateResponseDto
     */
    issuedAt: Date;
    /**
     * Certificate expiration date
     * @type {Date}
     * @memberof CertificateResponseDto
     */
    expiresAt: Date;
    /**
     * Base64-encoded PFX bundle (included only in download response)
     * @type {string}
     * @memberof CertificateResponseDto
     */
    pfx?: string;
}

/**
 * Check if a given object implements the CertificateResponseDto interface.
 */
export function instanceOfCertificateResponseDto(value: object): value is CertificateResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('commonName' in value) || value['commonName'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('fingerprint' in value) || value['fingerprint'] === undefined) return false;
    if (!('issuedAt' in value) || value['issuedAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function CertificateResponseDtoFromJSON(json: any): CertificateResponseDto {
    return CertificateResponseDtoFromJSONTyped(json, false);
}

export function CertificateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertificateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'status': json['status'],
        'commonName': json['commonName'],
        'serialNumber': json['serialNumber'],
        'fingerprint': json['fingerprint'],
        'issuedAt': (new Date(json['issuedAt'])),
        'expiresAt': (new Date(json['expiresAt'])),
        'pfx': json['pfx'] == null ? undefined : json['pfx'],
    };
}

export function CertificateResponseDtoToJSON(value?: CertificateResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'status': value['status'],
        'commonName': value['commonName'],
        'serialNumber': value['serialNumber'],
        'fingerprint': value['fingerprint'],
        'issuedAt': ((value['issuedAt']).toISOString()),
        'expiresAt': ((value['expiresAt']).toISOString()),
        'pfx': value['pfx'],
    };
}

